import api from '../api/axios'
import { API_URL } from '../config'
import { InfoApp, UserResponse } from '../types/auth'

export const authService = {
  info: async (): Promise<InfoApp> => (await api.get<InfoApp>('info/')).data,

  /** Usuario de la sesión actual; lanza (401) si no hay sesión. */
  me: async (): Promise<UserResponse> => (await api.get<UserResponse>('me/')).data,

  /** Login con usuario y contraseña (cuentas locales del admin). */
  login: async (username: string, password: string): Promise<UserResponse> =>
    (await api.post<UserResponse>('login/', { username, password })).data,

  logout: async (): Promise<void> => {
    await api.post('logout/')
  },

  /**
   * Dónde empieza el login por portal (U-Pasaporte). Es una navegación completa, no
   * una llamada: el backend guarda un nonce en la sesión y redirige al portal, que
   * vuelve al backend, que vuelve al SPA en `next`.
   */
  urlLoginVti: (next = '/app'): string => `${API_URL}auth/vti/?${new URLSearchParams({ next })}`,
}
